import React from 'react';

function PlainTableRow(props) {
  const { label, amount, showMargin, margin } = props;
  return (
    <tr>
      <td>{label}</td>
      <td className="text-right text-unimportant">{amount}</td>
      {showMargin && <td>{margin}</td>}
    </tr>
  );
}

PlainTableRow.defaultProps = {
  label: '',
  amount: '',
  margin: null,
  showMargin: false,
};

export default PlainTableRow;
